import React, { useState } from 'react';

import classnames from 'classnames';

import { TextButton } from 'components/uiLibrary/LinkButton';
import SpriteIcon from 'components/uiLibrary/SpriteIcon';
import Typography from 'components/uiLibrary/Typography';

import CommonTrans from 'components/Globals/CommonTrans';

import { TP } from 'constants/index';
import { SUBSCRIPTION_GROUP_IDENTIFIERS } from 'constants/subscriptions';

import { useTranslation } from 'src/i18n';

import classes from './PaywallFAQ.module.scss';

const FAQ_DATA = {
  [SUBSCRIPTION_GROUP_IDENTIFIERS.ARTIST_PROFESSIONAL]: [
    { question: 'FAQ_Q_ARTISTS_1', answer: 'FAQ_A_ARTISTS_1' },
    { question: 'FAQ_Q_ARTISTS_2', answer: 'FAQ_A_ARTISTS_2' },
    { question: 'FAQ_Q_ARTISTS_3', answer: 'FAQ_A_ARTISTS_3' },
    { question: 'FAQ_Q_ARTISTS_4', answer: 'FAQ_A_ARTISTS_4' },
    { question: 'FAQ_Q_ARTISTS_5', answer: 'FAQ_A_ARTISTS_5' },
    { question: 'FAQ_Q_ARTISTS_6', answer: 'FAQ_A_ARTISTS_6' },
    { question: 'FAQ_Q_ARTISTS_7', answer: 'FAQ_A_ARTISTS_7' },
    { question: 'FAQ_Q_ARTISTS_8', answer: 'FAQ_A_ARTISTS_8' },
    { question: 'FAQ_Q_ARTISTS_9', answer: 'FAQ_A_ARTISTS_9' },
    { question: 'FAQ_Q_ARTISTS_10', answer: 'FAQ_A_ARTISTS_10' },
    { question: 'FAQ_Q_ARTISTS_11', answer: 'FAQ_A_ARTISTS_11' },
    { question: 'FAQ_Q_ARTISTS_12', answer: 'FAQ_A_ARTISTS_12' },
    { question: 'FAQ_Q_ARTISTS_13', answer: 'FAQ_A_ARTISTS_13' },
    { question: 'FAQ_Q_ARTISTS_14', answer: 'FAQ_A_ARTISTS_14' },
    { question: 'FAQ_Q_ARTISTS_15', answer: 'FAQ_A_ARTISTS_15' },
    { question: 'FAQ_Q_ARTISTS_16', answer: 'FAQ_A_ARTISTS_16' },
    { question: 'FAQ_Q_ARTISTS_17', answer: 'FAQ_A_ARTISTS_17' },
    { question: 'FAQ_Q_ARTISTS_18', answer: 'FAQ_A_ARTISTS_18' },
    { question: 'FAQ_Q_ARTISTS_19', answer: 'FAQ_A_ARTISTS_19' },
    { question: 'FAQ_Q_ARTISTS_20', answer: 'FAQ_A_ARTISTS_20' },
    { question: 'FAQ_Q_ARTISTS_21', answer: 'FAQ_A_ARTISTS_21' },
    { question: 'FAQ_Q_ARTISTS_22', answer: 'FAQ_A_ARTISTS_22' },
    { question: 'FAQ_Q_ARTISTS_23', answer: 'FAQ_A_ARTISTS_23' },
    { question: 'FAQ_Q_ARTISTS_24', answer: 'FAQ_A_ARTISTS_24' },
    { question: 'FAQ_Q_ARTISTS_25', answer: 'FAQ_A_ARTISTS_25' },
    { question: 'FAQ_Q_ARTISTS_26', answer: 'FAQ_A_ARTISTS_26' },
    { question: 'FAQ_Q_ARTISTS_27', answer: 'FAQ_A_ARTISTS_27' },
    { question: 'FAQ_Q_ARTISTS_28', answer: 'FAQ_A_ARTISTS_28' },
    { question: 'FAQ_Q_ARTISTS_29', answer: 'FAQ_A_ARTISTS_29' },
    { question: 'FAQ_Q_ARTISTS_30', answer: 'FAQ_A_ARTISTS_30' },
    { question: 'FAQ_Q_ARTISTS_31', answer: 'FAQ_A_ARTISTS_31' },
    { question: 'FAQ_Q_ARTISTS_32', answer: 'FAQ_A_ARTISTS_32' },
    { question: 'FAQ_Q_ARTISTS_33', answer: 'FAQ_A_ARTISTS_33' },
    { question: 'FAQ_Q_ARTISTS_34', answer: 'FAQ_A_ARTISTS_34' },
  ],
  [SUBSCRIPTION_GROUP_IDENTIFIERS.CASTING_TOOL]: [
    { question: 'FAQ_Q_CASTING_1', answer: 'FAQ_A_CASTING_1' },
    { question: 'FAQ_Q_CASTING_2', answer: 'FAQ_A_CASTING_2' },
    { question: 'FAQ_Q_CASTING_3', answer: 'FAQ_A_CASTING_3' },
    { question: 'FAQ_Q_CASTING_4', answer: 'FAQ_A_CASTING_4' },
    { question: 'FAQ_Q_CASTING_5', answer: 'FAQ_A_CASTING_5' },
    { question: 'FAQ_Q_CASTING_6', answer: 'FAQ_A_CASTING_6' },
  ],
};

const QuestionAnswer = ({ question, answer }) => {
  const { t } = useTranslation('NS_NEW_FAQ');
  const [isOpen, setIsOpen] = useState(false);

  return (
    <div className={classes.questionAnswer} onClick={() => setIsOpen(!isOpen)}>
      <SpriteIcon className={classes.icon} icon={isOpen ? 'chevron_up' : 'chevron_down'} size={20} />
      <Typography variant="p" color={isOpen ? 'link' : 'primary'} size={13} weight="medium">
        {t(question)}
      </Typography>
      {isOpen && (
        <Typography variant="p" size={12} color="secondary">
          <CommonTrans i18nKey={answer} ns="NS_NEW_FAQ" />
        </Typography>
      )}
    </div>
  );
};

const PaywallFAQ = ({ className, identifier }) => {
  const [countToShow, setCountToShow] = useState(10);
  const { t } = useTranslation('NS_APP_GLOBALS');
  const groupFAQData = FAQ_DATA[identifier];

  if (!groupFAQData?.length) {
    return null;
  }

  return (
    <div className={classnames(classes.root, className)}>
      <Typography variant="p" size={13} weight="bold" color="purple">
        {t(`${TP}.FN_FAQS`)}
      </Typography>
      {groupFAQData.slice(0, countToShow).map(({ question, answer }) => (
        <QuestionAnswer key={question} question={question} answer={answer} />
      ))}
      {groupFAQData?.length > countToShow && (
        <TextButton onClick={() => setCountToShow(countToShow + 5)}>{t(`${TP}.FN_VIEW_MORE`)}</TextButton>
      )}
    </div>
  );
};

export default PaywallFAQ;
